<script>
import LaptopFilters from './LaptopFilters'

export default {
  components: {
    LaptopFilters,
  },
  data() {
    return {
      filtersLaptop: {},
    }
  },
  render: () => '',
}
</script>
